import { api } from '@/shared/api/client';
import type { CurrentUser } from '@/shared/api/types';

export interface LoginResponse {
  accessToken: string;
  accessExpiresAtUtc: string;
  user: CurrentUser;
}

export const authApi = {
  login: async (email: string, password: string) =>
    (await api.post<LoginResponse>('/api/v1/auth/login', { email, password })).data,

  logout: async () => (await api.post('/api/v1/auth/logout')).data,

  refresh: async () => (await api.post<LoginResponse>('/api/v1/auth/refresh')).data,

  me: async () => (await api.get<CurrentUser>('/api/v1/auth/me')).data,
};
